<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <h1>エラーが発生したので、運営事務局&lt;info@the-melon.com&gt;にお問い合わせください。</h1>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Page500'
}
</script>
